import { useState } from "react";
import { Input } from "@/components/ui/input";

// Parse « 14,9 » ou « 14.9 » -> 14.9. Retourne null si non parseable.
export function parseFrNumber(raw) {
  if (raw === null || raw === undefined) return null;
  const s = String(raw).trim().replace(",", ".");
  if (s === "" || s === "-") return s;
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : null;
}

const displayFr = (value) => {
  if (value === null || value === undefined || value === "") return "";
  return String(value).replace(".", ",");
};

/**
 * Champ numérique tolérant à la virgule française.
 * Conserve la saisie brute pendant l'édition (« 30, » reste affiché) et
 * remonte la valeur numérique parsée au parent.
 */
export function NumberField({ value, onValueChange, className, testid, onKeyDown, placeholder }) {
  const [draft, setDraft] = useState(null);

  const handleChange = (e) => {
    const raw = e.target.value;
    if (raw !== "" && !/^-?[0-9]*[.,]?[0-9]*$/.test(raw)) return;
    setDraft(raw);
    onValueChange(parseFrNumber(raw));
  };

  return (
    <Input
      type="text"
      inputMode="decimal"
      className={className}
      placeholder={placeholder}
      value={draft !== null ? draft : displayFr(value)}
      onChange={handleChange}
      onBlur={() => setDraft(null)}
      onKeyDown={onKeyDown}
      data-testid={testid}
    />
  );
}
